import { UnderConstructionPage } from '@components/app/UnderConstructionPage'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/staff/finder')({
    component: UnderConstructionPage,
    beforeLoad: requireRouteAudience(['staff']),
})
